module.exports = __webpack_public_path__ + "img/pro_four_2.67dd0d22.jpg";